// extracted by mini-css-extract-plugin
module.exports = {"img":"carousel_img__N6rO6","imageBox":"carousel_imageBox__30sGv"};